export const GENDER_OPTIONS = [
  {
    text: 'Male',
    value: 'MALE',
  },
  {
    text: 'Female',
    value: 'FEMALE',
  },
  {
    text: 'Other',
    value: 'OTHER',
  },
];
